// src/reducers/createListReducer.js
import { ACTIONS } from './listActions';

export function createListReducer(dataKey, totalKey) {
    return function listReducer(state, action) {
        switch (action.type) {
            case ACTIONS.FETCH_INIT:
                return { ...state, loading: true, error: '' };
            case ACTIONS.FETCH_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    [dataKey]: action.payload[dataKey],
                    [totalKey]: action.payload.total,
                };
            case ACTIONS.FETCH_FAILURE:
                return { ...state, loading: false, error: action.payload };
            case ACTIONS.SET_ORDER:
                return { ...state, order: action.payload };
            case ACTIONS.SET_ORDER_BY:
                return { ...state, orderBy: action.payload };
            case ACTIONS.SET_PAGE:
                return { ...state, page: action.payload };
            case ACTIONS.SET_ROWS_PER_PAGE:
                return { ...state, rowsPerPage: action.payload, page: 0 };
            case ACTIONS.UPDATE_COMMENTS:
                return {
                    ...state,
                    [dataKey]: state[dataKey].map(item =>
                        item.id === action.payload.id ? { ...item, comments: action.payload.comments } : item
                    ),
                };
            default:
                throw new Error(`Unhandled action type: ${action.type}`);
        }
    };
}  